module.exports = __webpack_public_path__ + "img/background-event.e57d84cf.jpg";